import domReady from '../helpers/dom-ready';
// import menuOpen from '../helpers/menu-helper';

export default class DashedBar {
  static init() {
    return new DashedBar();
  }

  constructor() {
    this.dashedBarContainers = [...document.querySelectorAll('.dashed-bar')];

    this.loopLines();

    window.addEventListener('resize', () => {
      this.loopLines();
    });
  }

  calcLines(c) {
    const container = c;
    if (!container) return;

    let width = container.scrollWidth;

    if (container.scrollHeight > container.scrollWidth) {
      width = container.scrollHeight;
    }

    const sectionOfFourPixelLines = width * 0.4;
    const sectionOfThreePixelLines = width * 0.3;
    const sectionOfTwoPixelLines = width * 0.2;
    const sectionOfOnePixelLines = width * 0.1;

    const fourPixelLinesQuantity = Math.floor(sectionOfFourPixelLines / (15 + 4));
    const threePixelLinesQuantity = Math.floor(sectionOfThreePixelLines / (15 + 3));
    const twoPixelLinesQuantity = Math.floor(sectionOfTwoPixelLines / (15 + 2));
    const onePixelLines4Quantity = Math.floor(sectionOfOnePixelLines / (15 + 1));

    for (let i = 0; i < fourPixelLinesQuantity; i += 1) {
      const line = document.createElement('span');
      line.classList.add('dashed-line');
      line.style.width = '4px';

      if (container.scrollHeight > container.scrollWidth) {
        line.style.width = '5px';
        line.style.height = '4px';
      }

      container.appendChild(line);
    }
    for (let i = 0; i < threePixelLinesQuantity; i += 1) {
      const line = document.createElement('span');
      line.classList.add('dashed-line');
      line.style.width = '3px';

      if (container.scrollHeight > container.scrollWidth) {
        line.style.width = '5px';
        line.style.height = '3px';
      }

      container.appendChild(line);
    }
    for (let i = 0; i < twoPixelLinesQuantity; i += 1) {
      const line = document.createElement('span');
      line.classList.add('dashed-line');
      line.style.width = '2px';

      if (container.scrollHeight > container.scrollWidth) {
        line.style.width = '5px';
        line.style.height = '2px';
      }

      container.appendChild(line);
    }
    for (let i = 0; i < onePixelLines4Quantity; i += 1) {
      const line = document.createElement('span');
      line.classList.add('dashed-line');
      line.style.width = '1px';

      if (container.scrollHeight > container.scrollWidth) {
        line.style.width = '5px';
        line.style.height = '1px';
      }

      container.appendChild(line);
    }
  }

  loopLines() {
    const lines = [...document.querySelectorAll('.dashed-line')];
    if (lines.length > 0) {
      lines.forEach((line) => {
        line.remove();
      });
    }

    if (this.dashedBarContainers.length > 0) {
      this.dashedBarContainers.forEach((container) => {
        if (container) this.calcLines(container);
      });
    }
  }
}


domReady(() => {
  DashedBar.init();
});
